import { z, ZodArray, ZodObject, ZodOptional } from 'zod/v4';
import { ZodMiniArray, ZodMiniObject, ZodMiniOptional } from 'zod/v4-mini';

export const BasicBool = z.boolean().meta({ kind: 'bool' });
export const BasicInt = z.number().int().meta({ kind: 'int' });
export const BasicString = z.string().meta({ kind: 'text' });
export const BasicDate = z.date().meta({
  kind: 'date-object',
  description: 'TypeScript Date object',
});

export const IsoDate = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}$/)
  .meta({
    kind: 'date',
    examples: ['2025-08-17'],
    description: 'ISO date YYYY-MM-DD',
  });

export const Note = BasicString.meta({ kind: 'note', description: 'Free text medical note' });

export type ZodObjectType = ZodMiniObject<any> | ZodObject<any>;
export const isZodObject = (schema?: any): schema is ZodObjectType =>
  schema instanceof ZodObject || schema instanceof ZodMiniObject;

export type ZodArrayType = ZodMiniArray<any> | ZodArray<any>;
export const isZodArray = (schema: any): schema is ZodArrayType =>
  schema instanceof ZodArray || schema instanceof ZodMiniArray;

export type ZodOptionalType = ZodOptional<any> | ZodMiniOptional<any>;
export const isZodOptional = (schema: any): schema is ZodOptionalType =>
  schema instanceof ZodOptional || schema instanceof ZodMiniOptional;

export type ZodSchemaTypes = ZodObjectType | ZodOptionalType;
